
import { createApp } from 'vue';
import store from '@storePath';
import Comment from '@componentPath/article/Comment';
import CommentNums from '@componentPath/article/CommentNums';

const comment_nums = createApp({
    name: 'ArticleCommentNums'
});

const comment = createApp({
    name: 'ArticleComment'
});

comment_nums.use(store);
comment.use(store);

comment.component('comment', Comment);
comment_nums.component('comment-nums', CommentNums);

comment_nums.config.devtools = true; // @todo 對此instance 開啟dev tool
comment.config.devtools = true; // @todo 對此instance 開啟dev tool
comment_nums.mount('#comment_nums');
comment.mount('#comment');
